document
  .querySelectorAll(".seed-starting-collapsible__item-title")
  .forEach((button) => {
    button.addEventListener("click", () => {
      const faqItem = button.parentElement;
      const answer = faqItem.querySelector(".faq-answer");

      // Check if the clicked item is already active
      const isActive = button.classList.contains(
        "seed-starting-collapsible__item-title--active"
      );

      // Close all answers and remove active classes
      document
        .querySelectorAll(".faq-answer")
        .forEach((ans) => ans.classList.remove("active"));
      document
        .querySelectorAll(".seed-starting-collapsible__item-title")
        .forEach((btn) => {
          btn.classList.remove("seed-starting-collapsible__item-title--active");
        });

      if (!isActive) {
        // Open the clicked item and add active class
        answer.classList.add("active");
        button.classList.add("seed-starting-collapsible__item-title--active");
      }
      // If the clicked item was active, it is now closed, and active classes are removed
    });
  });
